import React from 'react';
import "./PageNotFound.css";

import logo from "../../assets/svg/policia.svg";

const PageNotFound = () => {
    return (
        <div className='main'>
            <img className="logo-not-found" src={logo} alt="logo policia" />
            <h1 className='not-found-title'>Página no encontrada</h1>
            <p className='not-found-sub'>Lo sentimos, la página que estás buscando no existe.</p>
        </div>
    );
};

export default PageNotFound;